const auth_status = {
    page_title: 'Status uwierzytelnienia',
    title: 'Status uwierzytelnienia',
    description: 'Sprawdź status uwierzytelnienia.',
};
export default Object.freeze(auth_status);
